export const CREATE_COURIER = 'couriers/create';
export const RETRIEVE_COURIERS = 'couriers/retrieve';
export const RETRIEVE_COURIERAPPLIES= 'courierapplies/retrieve';
export const RETRIEVE_COURIER_MESSAGE = 'couriers/courier/retrieve/message';
export const RETRIEVE_COURIER_PLANNING = 'couriers/courier/retrieve/planning';
export const RETRIEVE_COURIER_ABSENCE = 'couriers/courier/retrieve/absences';
export const RETRIEVE_COURIER_EXTRA = 'couriers/courier/retrieve/extras';
export const RETRIEVE_COURIER = 'couriers/getById';
export const UPDATE_COURIER = 'couriers/update';
